import Vue from 'vue'

/* eslint-disable */
function functionWrapper(e) {
  /* add filters to handle event type before propagating to callback function for custom event handler */
  e.currentTarget.__handler__.fn(e)
}

Vue.directive('multiEvent', {
  bind(el, binding, vnode) {
    el.__handler__ = binding.value
    binding.value.evt.forEach((e) => el.addEventListener(e, functionWrapper))
  },
  unbind(el, binding) {
    el.__handler__.evt.forEach((e) => el.removeEventListener(e, functionWrapper))
    el.__handler__ = null
  }
})
/* eslint-disable */

// example v-multi-event="{ evt: ['click', 'keyup'], fn: toggleIcons }
